/* src/app/cardholders/cardholder-visahistory/cardholder-visahistory.component.css */
.fa {
  font-size: 9pt;
}
/*# sourceMappingURL=cardholder-visahistory.component.css.map */
